/**
 * Copyright (C) Siemens AG 2016-2025 ALL RIGHTS RESERVED.
 */
import {Injectable, inject} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {FeatureFlaggingService} from '../../services/feature-flagging.service';

@Injectable({
  providedIn: 'root',
})
export class BppFeatureFlagGuard implements CanActivate {
  private readonly featureFlaggingService = inject(FeatureFlaggingService);
  private readonly router = inject(Router);

  async canActivate(): Promise<boolean> {
    try {
      const featureFlags = await this.featureFlaggingService.load();
      if (featureFlags?.grantedApps?.includes('BPP')) {
        return true;
      }
    } catch {
      // do nothing
    }

    this.router.navigate(['/login'], {fragment: 'errorForbidden'});
    return false;
  }
}
